import { DialogConfirmation } from '@reapitform/common-ui'
import React, { useEffect } from 'react'
import { IDefaultSpecialTerms } from '../../../../../api/types'
import { useDefaultSpecialConditionDelete } from '../../../../../api/defaults/special-terms'

interface IDeleteConfirmationModal {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDefaultSpecialTerms[] | ((preData: IDefaultSpecialTerms[]) => IDefaultSpecialTerms[])) => void
  data?: IDefaultSpecialTerms
}

export const DeleteConfirmationModal: React.FC<IDeleteConfirmationModal> = ({
  data,
  isOpen,
  onOpenChange,
  refreshList,
}) => {
  const { isLoading, deleteSpecialCondition, isSuccess } = useDefaultSpecialConditionDelete(String(data?.id))

  const handleClose = () => onOpenChange(false)
  const handleConfirm = () => {
    deleteSpecialCondition(undefined)
  }

  useEffect(() => {
    if (!isSuccess || !data?.id) return
    refreshList((prevData) => prevData.filter((specialCondition) => specialCondition.id !== data.id))
    handleClose()
  }, [isSuccess])

  if (!data) return

  return (
    <DialogConfirmation
      isOpen={isOpen}
      message={`This action will permanently delete the special terms template ${data.title} and cannot be undone.`}
      onCancel={handleClose}
      onClose={handleClose}
      confirmButtonText="Delete"
      intent="danger"
      title="Delete Template"
      onConfirm={handleConfirm}
      isLoading={isLoading}
    />
  )
}
